import _defineProperty from "C:/Users/byron/Development/makeripples/platform/gatsby-sales/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _container2, _container3, _container4;

import { switchAnatomy as parts } from "@chakra-ui/anatomy";
import { calc, cssVar, mode } from "@chakra-ui/theme-tools";
var $width = cssVar("switch-track-width");
var $height = cssVar("switch-track-height");
var $diff = cssVar("switch-track-diff");
var diffValue = calc.subtract($width, $height);
var $translateX = cssVar("switch-thumb-x");

var baseStyleTrack = function baseStyleTrack(props) {
  var c = props.colorScheme;
  return {
    borderRadius: "full",
    p: "2px",
    width: [$width.reference],
    height: [$height.reference],
    transitionProperty: "common",
    transitionDuration: "fast",
    bg: mode("gray.300", "whiteAlpha.400")(props),
    _focus: {
      boxShadow: "outline"
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    },
    _checked: {
      bg: mode(c + ".500", c + ".200")(props)
    }
  };
};

var baseStyleThumb = {
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: [$height.reference],
  height: [$height.reference],
  _checked: {
    transform: "translateX(" + $translateX.reference + ")"
  }
};

var baseStyle = function baseStyle(props) {
  var _container;

  return {
    container: (_container = {}, _defineProperty(_container, $diff.variable, diffValue), _defineProperty(_container, $translateX.variable, $diff.reference), _defineProperty(_container, "_rtl", _defineProperty({}, $translateX.variable, calc($diff).negate().toString())), _container),
    track: baseStyleTrack(props),
    thumb: baseStyleThumb
  };
};

var sizes = {
  sm: {
    container: (_container2 = {}, _defineProperty(_container2, $width.variable, "1.375rem"), _defineProperty(_container2, $height.variable, "0.75rem"), _container2)
  },
  md: {
    container: (_container3 = {}, _defineProperty(_container3, $width.variable, "1.875rem"), _defineProperty(_container3, $height.variable, "1rem"), _container3)
  },
  lg: {
    container: (_container4 = {}, _defineProperty(_container4, $width.variable, "2.875rem"), _defineProperty(_container4, $height.variable, "1.5rem"), _container4)
  }
};
var defaultProps = {
  size: "md",
  colorScheme: "blue"
};
export default {
  parts: parts.keys,
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: defaultProps
};